import { useHarryShell } from './harryShellContext';
import { AssistantHeaderIcon } from './AssistantAvatar';
import { monoIconButton } from '@/components/mono/iconButton';

/** Header icon — opens the Navigator, drawn in the workspace's voice. */
export function HarryHeaderActions() {
  const { togglePanel, panelOpen, voice } = useHarryShell();

  return (
    <button
      type="button"
      onClick={togglePanel}
      className={monoIconButton('sm', '', panelOpen)}
      title="Navigator: say what you want to do"
      aria-label="Open the Navigator"
    >
      <AssistantHeaderIcon mode={voice} />
    </button>
  );
}
